import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  popup: boolean;
  message: string;
  popupMessage: string;
  password: string;
  confirmPassword: string;
  error: boolean;
};

const initialState: StateInterface = {
  isFetching: false,
  popup: false,
  message: "",
  popupMessage: "",
  password: "",
  confirmPassword: "",
  error: false
};

export const forgotPasswordReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.PAGE_FORGOT_PASSWORD_REQUEST:
      return { 
        ...state,
        isFetching: true,
        error: false
      };

    case Constants.PAGE_FORGOT_PASSWORD_SUCCESS:
      return { 
        ...state,
        isFetching: false
      };

    case Constants.PAGE_FORGOT_PASSWORD_FAILURE:
      return { 
        ...state,
        isFetching: false,
        message: action.payload?.err.message,
        error: true
      };

    case Constants.PAGE_FORGOT_PASSWORD_OPEN_POPUP:
      return { ...state,
        popup: true,
        popupMessage: action.payload?.message
      };

    case Constants.PAGE_FORGOT_PASSWORD_CLOSE_POPUP:
      return { ...state,
        popup: false,
        popupMessage: ""
      };

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
